import React, { useState } from "react";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-gray-950 border-b border-gray-800 sticky top-0 z-10">
      <div className="container mx-auto flex items-center justify-between px-6 py-4">
        <a href="#about" className="text-lg font-semibold text-gray-100">
          Daniel Coates
        </a>
        <button
          className="md:hidden text-gray-400 hover:text-gray-100"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
        <nav className={`${menuOpen ? "flex" : "hidden"} md:flex flex-col md:flex-row absolute md:relative top-full left-0 right-0 bg-gray-950 md:bg-transparent border-b md:border-0 border-gray-800 items-center md:space-x-8 py-4 md:py-0 px-6 md:px-0`}>
          <a href="#experience" className="block py-2 md:py-0 text-sm text-gray-400 hover:text-gray-100 transition-colors" onClick={() => setMenuOpen(false)}>
            Experience
          </a>
          <a href="#projects" className="block py-2 md:py-0 text-sm text-gray-400 hover:text-gray-100 transition-colors" onClick={() => setMenuOpen(false)}>
            Projects
          </a>
          <a href="#contact" className="block py-2 md:py-0 text-sm bg-indigo-600 text-white px-4 md:px-4 py-2 rounded-lg hover:bg-indigo-700 transition-colors mt-2 md:mt-0 text-center" onClick={() => setMenuOpen(false)}>
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/components/Navbar.js